import gql from 'graphql-tag';

export const CONTROL_PHOTO_FRAGMENT = gql`
    fragment ControlPhotoFragment on ControlPhoto {
        deliveryId
        setupInstructionId
        taskInstructionId
        type
        url
        photoIndex
        state
        stateHistory {
            state
            createdAt
            createdBy
            createdByName
        }
        issueType {
            isBadQuality
            isBadQuantity
        }
        comment
        isMandatory
        microstoreColumn {
            name
        }
    }
`;
